/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddOrRemoveUserIpRestrictionRequest } from '../api-models';
// @ts-ignore
import { AddViventiumConfigurationRequest } from '../api-models';
// @ts-ignore
import { AdminDashboardResponse } from '../api-models';
// @ts-ignore
import { BaseMenuDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewDatabaseDto } from '../api-models';
// @ts-ignore
import { BulkResetPasswordRequest } from '../api-models';
// @ts-ignore
import { ConfigurationSettingBulkUpsertModel } from '../api-models';
// @ts-ignore
import { CreateAdminRequest } from '../api-models';
// @ts-ignore
import { CreateBaseMenuItemRequest } from '../api-models';
// @ts-ignore
import { Employee } from '../api-models';
// @ts-ignore
import { FacilityGetByIdResponse } from '../api-models';
// @ts-ignore
import { FacilityMenuDto } from '../api-models';
// @ts-ignore
import { FacilityRoleResponse } from '../api-models';
// @ts-ignore
import { FacilitySearchUserRequest } from '../api-models';
// @ts-ignore
import { FacilitySetupRequest } from '../api-models';
// @ts-ignore
import { FacilitySetupResponse } from '../api-models';
// @ts-ignore
import { FacilityUpdateRequest } from '../api-models';
// @ts-ignore
import { FacilityUpdateResponse } from '../api-models';
// @ts-ignore
import { GetFacilitiesBussinessResponse } from '../api-models';
// @ts-ignore
import { GetFacilitiesBussinessResponseV2 } from '../api-models';
// @ts-ignore
import { KeyValuePairOfStringAndString } from '../api-models';
// @ts-ignore
import { LockUserAccountRequest } from '../api-models';
// @ts-ignore
import { ModelString } from '../api-models';
// @ts-ignore
import { OkResult } from '../api-models';
// @ts-ignore
import { OnboardEmployeesRequest } from '../api-models';
// @ts-ignore
import { PageModelOfGlobalViewPhones } from '../api-models';
// @ts-ignore
import { ResendOTPAllUnregisteredRequest } from '../api-models';
// @ts-ignore
import { ResendOtpAllUnregisteredResponse } from '../api-models';
// @ts-ignore
import { ResendOtpFromAdminPortalRequest } from '../api-models';
// @ts-ignore
import { Response } from '../api-models';
// @ts-ignore
import { SearchUserRequest } from '../api-models';
// @ts-ignore
import { SearchUserResponseOfEmployeeModel } from '../api-models';
// @ts-ignore
import { SetFacilityMenuPermissionsRequest } from '../api-models';
// @ts-ignore
import { Timezone } from '../api-models';
// @ts-ignore
import { UpdateBaseMenuItemRequest } from '../api-models';
// @ts-ignore
import { UpdateViventiumConfigurationRequest } from '../api-models';
// @ts-ignore
import { ViventiumConfiguration } from '../api-models';
/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminBaseMenuIdDelete', 'id', id)
            const localVarPath = `/Admin/base-menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminBaseMenuIdGet', 'id', id)
            const localVarPath = `/Admin/base-menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBaseMenuItemRequest} [updateBaseMenuItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdPut: async (id: string, updateBaseMenuItemRequest?: UpdateBaseMenuItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminBaseMenuIdPut', 'id', id)
            const localVarPath = `/Admin/base-menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBaseMenuItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBaseMenuItemRequest} [createBaseMenuItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuPost: async (createBaseMenuItemRequest?: CreateBaseMenuItemRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/base-menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBaseMenuItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenusGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/base-menus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkResetPasswordRequest} [bulkResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkResetPasswordPut: async (bulkResetPasswordRequest?: BulkResetPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/bulk-reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheFacilityIdKeyDelete: async (facilityId: string, key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminCacheFacilityIdKeyDelete', 'facilityId', facilityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminCacheFacilityIdKeyDelete', 'key', key)
            const localVarPath = `/Admin/cache/{facilityId}/{key}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheFacilityIdKeyGet: async (facilityId: string, key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminCacheFacilityIdKeyGet', 'facilityId', facilityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminCacheFacilityIdKeyGet', 'key', key)
            const localVarPath = `/Admin/cache/{facilityId}/{key}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheKeyDelete: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminCacheKeyDelete', 'key', key)
            const localVarPath = `/Admin/cache/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheKeyGet: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminCacheKeyGet', 'key', key)
            const localVarPath = `/Admin/cache/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminConfigFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/config/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdKeyGet: async (key: string, facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminConfigFacilityIdKeyGet', 'key', key)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminConfigFacilityIdKeyGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/config/{facilityId}/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdKeyValuePut: async (facilityId: string, key: string, value: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminConfigFacilityIdKeyValuePut', 'facilityId', facilityId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('adminConfigFacilityIdKeyValuePut', 'key', key)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('adminConfigFacilityIdKeyValuePut', 'value', value)
            const localVarPath = `/Admin/config/{facilityId}/{key}/{value}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {ConfigurationSettingBulkUpsertModel} [configurationSettingBulkUpsertModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdPut: async (facilityId: string, configurationSettingBulkUpsertModel?: ConfigurationSettingBulkUpsertModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminConfigFacilityIdPut', 'facilityId', facilityId)
            const localVarPath = `/Admin/config/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurationSettingBulkUpsertModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDatabaseVersionFacilityIdGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminDatabaseVersionFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/database-version/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilitiesGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdDelete: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdDelete', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/Facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdMenuGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdMenuGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/menu`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {SetFacilityMenuPermissionsRequest} [setFacilityMenuPermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdMenuPermissionsPost: async (facilityId: string, setFacilityMenuPermissionsRequest?: SetFacilityMenuPermissionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdMenuPermissionsPost', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/menu-permissions`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setFacilityMenuPermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {FacilityUpdateRequest} [facilityUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdPut: async (facilityId: string, facilityUpdateRequest?: FacilityUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdPut', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilityUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdRolesGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdRolesGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/roles`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdUsersGet: async (facilityId: string, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdUsersGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/users`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdViventiumConfigurationsGet: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdViventiumConfigurationsGet', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/viventium-configurations`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {AddViventiumConfigurationRequest} [addViventiumConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdViventiumConfigurationsPost: async (facilityId: string, addViventiumConfigurationRequest?: AddViventiumConfigurationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminFacilityFacilityIdViventiumConfigurationsPost', 'facilityId', facilityId)
            const localVarPath = `/Admin/facility/{facilityId}/viventium-configurations`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addViventiumConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityGet: async (filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [onlyShowNewScheduler] 
         * @param {SearchUserRequest} [searchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilitySearchUsersPost: async (onlyShowNewScheduler?: boolean, searchUserRequest?: SearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/facility/search-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (onlyShowNewScheduler !== undefined) {
                localVarQueryParameter['onlyShowNewScheduler'] = onlyShowNewScheduler;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {ModelString} [phone] 
         * @param {string} [userName] 
         * @param {boolean} [phoneNumberConfirmed] 
         * @param {boolean} [isRegistered] 
         * @param {boolean} [isLocked] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalUserViewGet: async (search?: string, phone?: ModelString, userName?: string, phoneNumberConfirmed?: boolean, isRegistered?: boolean, isLocked?: boolean, pageNumber?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/global-user-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (phoneNumberConfirmed !== undefined) {
                localVarQueryParameter['phoneNumberConfirmed'] = phoneNumberConfirmed;
            }

            if (isRegistered !== undefined) {
                localVarQueryParameter['isRegistered'] = isRegistered;
            }

            if (isLocked !== undefined) {
                localVarQueryParameter['isLocked'] = isLocked;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLockUserAccountPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/lockUserAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OnboardEmployeesRequest} [onboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOnboardEmployeesPost: async (onboardEmployeesRequest?: OnboardEmployeesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/onboard-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardEmployeesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FacilitySetupRequest} [facilitySetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOnboardFacilityPost: async (facilitySetupRequest?: FacilitySetupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/onboard-facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitySetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPopulateDbConfigPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/populate-db-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRandomPasswordPost: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/random-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRefreshTeamSupportCustomersPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/refresh-team-support-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterFacilityChatUsersFacilityIdPut: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminRegisterFacilityChatUsersFacilityIdPut', 'facilityId', facilityId)
            const localVarPath = `/Admin/register-facility-chat-users/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateAdminRequest} [createAdminRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterSystemUserPost: async (createAdminRequest?: CreateAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/register-system-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendOTPAllUnregisteredRequest} [resendOTPAllUnregisteredRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResendOtpAllUnregisteredPost: async (resendOTPAllUnregisteredRequest?: ResendOTPAllUnregisteredRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/resend-otp-all-unregistered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendOTPAllUnregisteredRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendOtpFromAdminPortalRequest} [resendOtpFromAdminPortalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResendOtpPut: async (resendOtpFromAdminPortalRequest?: ResendOtpFromAdminPortalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/resend-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendOtpFromAdminPortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResetPasswordPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/scheduled-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsFacilityIdPost: async (facilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('adminScheduledJobsFacilityIdPost', 'facilityId', facilityId)
            const localVarPath = `/Admin/scheduled-jobs/{facilityId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/scheduled-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSchedulerDbMigrateAllPut: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/scheduler-db-migrate-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FacilitySearchUserRequest} [facilitySearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchFacilityEmployeesPost: async (facilitySearchUserRequest?: FacilitySearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/search-facility-employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(facilitySearchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTimezonesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/timezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnlockUserAccountPut: async (lockUserAccountRequest?: LockUserAccountRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/unlockUserAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockUserAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddOrRemoveUserIpRestrictionRequest} [addOrRemoveUserIpRestrictionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionDelete: async (addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/user-ip-restriction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrRemoveUserIpRestrictionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddOrRemoveUserIpRestrictionRequest} [addOrRemoveUserIpRestrictionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionPost: async (addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/user-ip-restriction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrRemoveUserIpRestrictionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionUserNameGet: async (userName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            assertParamExists('adminUserIpRestrictionUserNameGet', 'userName', userName)
            const localVarPath = `/Admin/user-ip-restriction/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [isUsingSaasAuthentication] 
         * @param {boolean} [isUsingMobile] 
         * @param {boolean} [isUsingSbvPro] 
         * @param {boolean} [addedToSaas] 
         * @param {string} [filter] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV2FacilitiesGet: async (facilityId?: string, isUsingSaasAuthentication?: boolean, isUsingMobile?: boolean, isUsingSbvPro?: boolean, addedToSaas?: boolean, filter?: string, pageSize?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/v2/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (isUsingSaasAuthentication !== undefined) {
                localVarQueryParameter['isUsingSaasAuthentication'] = isUsingSaasAuthentication;
            }

            if (isUsingMobile !== undefined) {
                localVarQueryParameter['isUsingMobile'] = isUsingMobile;
            }

            if (isUsingSbvPro !== undefined) {
                localVarQueryParameter['isUsingSbvPro'] = isUsingSbvPro;
            }

            if (addedToSaas !== undefined) {
                localVarQueryParameter['addedToSaas'] = addedToSaas;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [isUsingSaasAuthentication] 
         * @param {boolean} [isUsingMobile] 
         * @param {boolean} [isUsingSbvPro] 
         * @param {boolean} [addedToSaas] 
         * @param {string} [filter] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV2FacilityGet: async (facilityId?: string, isUsingSaasAuthentication?: boolean, isUsingMobile?: boolean, isUsingSbvPro?: boolean, addedToSaas?: boolean, filter?: string, pageSize?: number, page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Admin/v2/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (isUsingSaasAuthentication !== undefined) {
                localVarQueryParameter['isUsingSaasAuthentication'] = isUsingSaasAuthentication;
            }

            if (isUsingMobile !== undefined) {
                localVarQueryParameter['isUsingMobile'] = isUsingMobile;
            }

            if (isUsingSbvPro !== undefined) {
                localVarQueryParameter['isUsingSbvPro'] = isUsingSbvPro;
            }

            if (addedToSaas !== undefined) {
                localVarQueryParameter['addedToSaas'] = addedToSaas;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} viventiumConfigurationId 
         * @param {UpdateViventiumConfigurationRequest} [updateViventiumConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViventiumConfigurationViventiumConfigurationIdPut: async (viventiumConfigurationId: string, updateViventiumConfigurationRequest?: UpdateViventiumConfigurationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'viventiumConfigurationId' is not null or undefined
            assertParamExists('adminViventiumConfigurationViventiumConfigurationIdPut', 'viventiumConfigurationId', viventiumConfigurationId)
            const localVarPath = `/Admin/viventium-configuration/{viventiumConfigurationId}`
                .replace(`{${"viventiumConfigurationId"}}`, encodeURIComponent(String(viventiumConfigurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateViventiumConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBaseMenuIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBaseMenuIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBaseMenuIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseMenuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBaseMenuIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBaseMenuItemRequest} [updateBaseMenuItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBaseMenuIdPut(id: string, updateBaseMenuItemRequest?: UpdateBaseMenuItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseMenuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBaseMenuIdPut(id, updateBaseMenuItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateBaseMenuItemRequest} [createBaseMenuItemRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBaseMenuPost(createBaseMenuItemRequest?: CreateBaseMenuItemRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseMenuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBaseMenuPost(createBaseMenuItemRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBaseMenusGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseMenuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBaseMenusGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkResetPasswordRequest} [bulkResetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBulkResetPasswordPut(bulkResetPasswordRequest?: BulkResetPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBulkResetPasswordPut(bulkResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCacheFacilityIdKeyDelete(facilityId: string, key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCacheFacilityIdKeyDelete(facilityId, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCacheFacilityIdKeyGet(facilityId: string, key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCacheFacilityIdKeyGet(facilityId, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCacheKeyDelete(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCacheKeyDelete(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCacheKeyGet(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCacheKeyGet(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigFacilityIdGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KeyValuePairOfStringAndString>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigFacilityIdKeyGet(key: string, facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyValuePairOfStringAndString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigFacilityIdKeyGet(key, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {string} key 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigFacilityIdKeyValuePut(facilityId: string, key: string, value: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigFacilityIdKeyValuePut(facilityId, key, value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {ConfigurationSettingBulkUpsertModel} [configurationSettingBulkUpsertModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminConfigFacilityIdPut(facilityId: string, configurationSettingBulkUpsertModel?: ConfigurationSettingBulkUpsertModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminConfigFacilityIdPut(facilityId, configurationSettingBulkUpsertModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDatabaseVersionFacilityIdGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewDatabaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDatabaseVersionFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilitiesGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacilitiesBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilitiesGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdDelete(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdDelete(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityGetByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdMenuGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityMenuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdMenuGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {SetFacilityMenuPermissionsRequest} [setFacilityMenuPermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdMenuPermissionsPost(facilityId: string, setFacilityMenuPermissionsRequest?: SetFacilityMenuPermissionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityMenuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdMenuPermissionsPost(facilityId, setFacilityMenuPermissionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {FacilityUpdateRequest} [facilityUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdPut(facilityId: string, facilityUpdateRequest?: FacilityUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdPut(facilityId, facilityUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdRolesGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityRoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdRolesGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdUsersGet(facilityId: string, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResponseOfEmployeeModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdUsersGet(facilityId, pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdViventiumConfigurationsGet(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViventiumConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdViventiumConfigurationsGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {AddViventiumConfigurationRequest} [addViventiumConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityFacilityIdViventiumConfigurationsPost(facilityId: string, addViventiumConfigurationRequest?: AddViventiumConfigurationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityFacilityIdViventiumConfigurationsPost(facilityId, addViventiumConfigurationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilityGet(filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacilitiesBussinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilityGet(filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [onlyShowNewScheduler] 
         * @param {SearchUserRequest} [searchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFacilitySearchUsersPost(onlyShowNewScheduler?: boolean, searchUserRequest?: SearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResponseOfEmployeeModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFacilitySearchUsersPost(onlyShowNewScheduler, searchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {ModelString} [phone] 
         * @param {string} [userName] 
         * @param {boolean} [phoneNumberConfirmed] 
         * @param {boolean} [isRegistered] 
         * @param {boolean} [isLocked] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGlobalUserViewGet(search?: string, phone?: ModelString, userName?: string, phoneNumberConfirmed?: boolean, isRegistered?: boolean, isLocked?: boolean, pageNumber?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageModelOfGlobalViewPhones>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGlobalUserViewGet(search, phone, userName, phoneNumberConfirmed, isRegistered, isLocked, pageNumber, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLockUserAccountPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLockUserAccountPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OnboardEmployeesRequest} [onboardEmployeesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOnboardEmployeesPost(onboardEmployeesRequest?: OnboardEmployeesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitySetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOnboardEmployeesPost(onboardEmployeesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FacilitySetupRequest} [facilitySetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOnboardFacilityPost(facilitySetupRequest?: FacilitySetupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilitySetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOnboardFacilityPost(facilitySetupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPopulateDbConfigPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewDatabaseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPopulateDbConfigPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRandomPasswordPost(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRandomPasswordPost(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRefreshTeamSupportCustomersPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRefreshTeamSupportCustomersPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRegisterFacilityChatUsersFacilityIdPut(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRegisterFacilityChatUsersFacilityIdPut(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateAdminRequest} [createAdminRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRegisterSystemUserPost(createAdminRequest?: CreateAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRegisterSystemUserPost(createAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResendOTPAllUnregisteredRequest} [resendOTPAllUnregisteredRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResendOtpAllUnregisteredPost(resendOTPAllUnregisteredRequest?: ResendOTPAllUnregisteredRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendOtpAllUnregisteredResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResendOtpAllUnregisteredPost(resendOTPAllUnregisteredRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResendOtpFromAdminPortalRequest} [resendOtpFromAdminPortalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResendOtpPut(resendOtpFromAdminPortalRequest?: ResendOtpFromAdminPortalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResendOtpPut(resendOtpFromAdminPortalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminResetPasswordPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminResetPasswordPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminScheduledJobsDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminScheduledJobsDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminScheduledJobsFacilityIdPost(facilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminScheduledJobsFacilityIdPost(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminScheduledJobsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminScheduledJobsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSchedulerDbMigrateAllPut(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSchedulerDbMigrateAllPut(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {FacilitySearchUserRequest} [facilitySearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSearchFacilityEmployeesPost(facilitySearchUserRequest?: FacilitySearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Employee>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSearchFacilityEmployeesPost(facilitySearchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTimezonesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Timezone>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTimezonesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LockUserAccountRequest} [lockUserAccountRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUnlockUserAccountPut(lockUserAccountRequest?: LockUserAccountRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUnlockUserAccountPut(lockUserAccountRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddOrRemoveUserIpRestrictionRequest} [addOrRemoveUserIpRestrictionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserIpRestrictionDelete(addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserIpRestrictionDelete(addOrRemoveUserIpRestrictionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddOrRemoveUserIpRestrictionRequest} [addOrRemoveUserIpRestrictionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserIpRestrictionPost(addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserIpRestrictionPost(addOrRemoveUserIpRestrictionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUserIpRestrictionUserNameGet(userName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUserIpRestrictionUserNameGet(userName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [isUsingSaasAuthentication] 
         * @param {boolean} [isUsingMobile] 
         * @param {boolean} [isUsingSbvPro] 
         * @param {boolean} [addedToSaas] 
         * @param {string} [filter] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV2FacilitiesGet(facilityId?: string, isUsingSaasAuthentication?: boolean, isUsingMobile?: boolean, isUsingSbvPro?: boolean, addedToSaas?: boolean, filter?: string, pageSize?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacilitiesBussinessResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV2FacilitiesGet(facilityId, isUsingSaasAuthentication, isUsingMobile, isUsingSbvPro, addedToSaas, filter, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [facilityId] 
         * @param {boolean} [isUsingSaasAuthentication] 
         * @param {boolean} [isUsingMobile] 
         * @param {boolean} [isUsingSbvPro] 
         * @param {boolean} [addedToSaas] 
         * @param {string} [filter] 
         * @param {number} [pageSize] 
         * @param {number} [page] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminV2FacilityGet(facilityId?: string, isUsingSaasAuthentication?: boolean, isUsingMobile?: boolean, isUsingSbvPro?: boolean, addedToSaas?: boolean, filter?: string, pageSize?: number, page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacilitiesBussinessResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminV2FacilityGet(facilityId, isUsingSaasAuthentication, isUsingMobile, isUsingSbvPro, addedToSaas, filter, pageSize, page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} viventiumConfigurationId 
         * @param {UpdateViventiumConfigurationRequest} [updateViventiumConfigurationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminViventiumConfigurationViventiumConfigurationIdPut(viventiumConfigurationId: string, updateViventiumConfigurationRequest?: UpdateViventiumConfigurationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminViventiumConfigurationViventiumConfigurationIdPut(viventiumConfigurationId, updateViventiumConfigurationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminApiAdminBaseMenuIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdDelete(requestParameters: AdminApiAdminBaseMenuIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminBaseMenuIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminBaseMenuIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdGet(requestParameters: AdminApiAdminBaseMenuIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseMenuDto> {
            return localVarFp.adminBaseMenuIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminBaseMenuIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuIdPut(requestParameters: AdminApiAdminBaseMenuIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseMenuDto> {
            return localVarFp.adminBaseMenuIdPut(requestParameters.id, requestParameters.updateBaseMenuItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminBaseMenuPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenuPost(requestParameters: AdminApiAdminBaseMenuPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseMenuDto> {
            return localVarFp.adminBaseMenuPost(requestParameters.createBaseMenuItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBaseMenusGet(options?: AxiosRequestConfig): AxiosPromise<Array<BaseMenuDto>> {
            return localVarFp.adminBaseMenusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminBulkResetPasswordPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBulkResetPasswordPut(requestParameters: AdminApiAdminBulkResetPasswordPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Response> {
            return localVarFp.adminBulkResetPasswordPut(requestParameters.bulkResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminCacheFacilityIdKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheFacilityIdKeyDelete(requestParameters: AdminApiAdminCacheFacilityIdKeyDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCacheFacilityIdKeyDelete(requestParameters.facilityId, requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminCacheFacilityIdKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheFacilityIdKeyGet(requestParameters: AdminApiAdminCacheFacilityIdKeyGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCacheFacilityIdKeyGet(requestParameters.facilityId, requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminCacheKeyDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheKeyDelete(requestParameters: AdminApiAdminCacheKeyDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCacheKeyDelete(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminCacheKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCacheKeyGet(requestParameters: AdminApiAdminCacheKeyGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCacheKeyGet(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminConfigFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdGet(requestParameters: AdminApiAdminConfigFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<KeyValuePairOfStringAndString>> {
            return localVarFp.adminConfigFacilityIdGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminConfigFacilityIdKeyGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdKeyGet(requestParameters: AdminApiAdminConfigFacilityIdKeyGetRequest, options?: AxiosRequestConfig): AxiosPromise<KeyValuePairOfStringAndString> {
            return localVarFp.adminConfigFacilityIdKeyGet(requestParameters.key, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminConfigFacilityIdKeyValuePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdKeyValuePut(requestParameters: AdminApiAdminConfigFacilityIdKeyValuePutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminConfigFacilityIdKeyValuePut(requestParameters.facilityId, requestParameters.key, requestParameters.value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminConfigFacilityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminConfigFacilityIdPut(requestParameters: AdminApiAdminConfigFacilityIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminConfigFacilityIdPut(requestParameters.facilityId, requestParameters.configurationSettingBulkUpsertModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDashboardGet(options?: AxiosRequestConfig): AxiosPromise<AdminDashboardResponse> {
            return localVarFp.adminDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminDatabaseVersionFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDatabaseVersionFacilityIdGet(requestParameters: AdminApiAdminDatabaseVersionFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewDatabaseDto> {
            return localVarFp.adminDatabaseVersionFacilityIdGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilitiesGet(requestParameters: AdminApiAdminFacilitiesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetFacilitiesBussinessResponse> {
            return localVarFp.adminFacilitiesGet(requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdDelete(requestParameters: AdminApiAdminFacilityFacilityIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.adminFacilityFacilityIdDelete(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdGet(requestParameters: AdminApiAdminFacilityFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<FacilityGetByIdResponse> {
            return localVarFp.adminFacilityFacilityIdGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdMenuGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdMenuGet(requestParameters: AdminApiAdminFacilityFacilityIdMenuGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<FacilityMenuDto>> {
            return localVarFp.adminFacilityFacilityIdMenuGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdMenuPermissionsPost(requestParameters: AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest, options?: AxiosRequestConfig): AxiosPromise<Array<FacilityMenuDto>> {
            return localVarFp.adminFacilityFacilityIdMenuPermissionsPost(requestParameters.facilityId, requestParameters.setFacilityMenuPermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdPut(requestParameters: AdminApiAdminFacilityFacilityIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<FacilityUpdateResponse> {
            return localVarFp.adminFacilityFacilityIdPut(requestParameters.facilityId, requestParameters.facilityUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdRolesGet(requestParameters: AdminApiAdminFacilityFacilityIdRolesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<FacilityRoleResponse>> {
            return localVarFp.adminFacilityFacilityIdRolesGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdUsersGet(requestParameters: AdminApiAdminFacilityFacilityIdUsersGetRequest, options?: AxiosRequestConfig): AxiosPromise<SearchUserResponseOfEmployeeModel> {
            return localVarFp.adminFacilityFacilityIdUsersGet(requestParameters.facilityId, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdViventiumConfigurationsGet(requestParameters: AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<ViventiumConfiguration>> {
            return localVarFp.adminFacilityFacilityIdViventiumConfigurationsGet(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityFacilityIdViventiumConfigurationsPost(requestParameters: AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminFacilityFacilityIdViventiumConfigurationsPost(requestParameters.facilityId, requestParameters.addViventiumConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilityGet(requestParameters: AdminApiAdminFacilityGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetFacilitiesBussinessResponse> {
            return localVarFp.adminFacilityGet(requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminFacilitySearchUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFacilitySearchUsersPost(requestParameters: AdminApiAdminFacilitySearchUsersPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<SearchUserResponseOfEmployeeModel> {
            return localVarFp.adminFacilitySearchUsersPost(requestParameters.onlyShowNewScheduler, requestParameters.searchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminGlobalUserViewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalUserViewGet(requestParameters: AdminApiAdminGlobalUserViewGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PageModelOfGlobalViewPhones> {
            return localVarFp.adminGlobalUserViewGet(requestParameters.search, requestParameters.phone, requestParameters.userName, requestParameters.phoneNumberConfirmed, requestParameters.isRegistered, requestParameters.isLocked, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminLockUserAccountPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLockUserAccountPut(requestParameters: AdminApiAdminLockUserAccountPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.adminLockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminOnboardEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOnboardEmployeesPost(requestParameters: AdminApiAdminOnboardEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FacilitySetupResponse> {
            return localVarFp.adminOnboardEmployeesPost(requestParameters.onboardEmployeesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminOnboardFacilityPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOnboardFacilityPost(requestParameters: AdminApiAdminOnboardFacilityPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FacilitySetupResponse> {
            return localVarFp.adminOnboardFacilityPost(requestParameters.facilitySetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPopulateDbConfigPut(options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewDatabaseDto> {
            return localVarFp.adminPopulateDbConfigPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminRandomPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRandomPasswordPost(requestParameters: AdminApiAdminRandomPasswordPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.adminRandomPasswordPost(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRefreshTeamSupportCustomersPost(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRefreshTeamSupportCustomersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterFacilityChatUsersFacilityIdPut(requestParameters: AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRegisterFacilityChatUsersFacilityIdPut(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminRegisterSystemUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterSystemUserPost(requestParameters: AdminApiAdminRegisterSystemUserPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRegisterSystemUserPost(requestParameters.createAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminResendOtpAllUnregisteredPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResendOtpAllUnregisteredPost(requestParameters: AdminApiAdminResendOtpAllUnregisteredPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ResendOtpAllUnregisteredResponse> {
            return localVarFp.adminResendOtpAllUnregisteredPost(requestParameters.resendOTPAllUnregisteredRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminResendOtpPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResendOtpPut(requestParameters: AdminApiAdminResendOtpPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminResendOtpPut(requestParameters.resendOtpFromAdminPortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminResetPasswordPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminResetPasswordPut(requestParameters: AdminApiAdminResetPasswordPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.adminResetPasswordPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsDelete(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminScheduledJobsDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminScheduledJobsFacilityIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsFacilityIdPost(requestParameters: AdminApiAdminScheduledJobsFacilityIdPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminScheduledJobsFacilityIdPost(requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminScheduledJobsPost(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminScheduledJobsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSchedulerDbMigrateAllPut(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminSchedulerDbMigrateAllPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminSearchFacilityEmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchFacilityEmployeesPost(requestParameters: AdminApiAdminSearchFacilityEmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<Employee>> {
            return localVarFp.adminSearchFacilityEmployeesPost(requestParameters.facilitySearchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTimezonesGet(options?: AxiosRequestConfig): AxiosPromise<Array<Timezone>> {
            return localVarFp.adminTimezonesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminUnlockUserAccountPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnlockUserAccountPut(requestParameters: AdminApiAdminUnlockUserAccountPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<OkResult> {
            return localVarFp.adminUnlockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminUserIpRestrictionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionDelete(requestParameters: AdminApiAdminUserIpRestrictionDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUserIpRestrictionDelete(requestParameters.addOrRemoveUserIpRestrictionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminUserIpRestrictionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionPost(requestParameters: AdminApiAdminUserIpRestrictionPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUserIpRestrictionPost(requestParameters.addOrRemoveUserIpRestrictionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminUserIpRestrictionUserNameGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUserIpRestrictionUserNameGet(requestParameters: AdminApiAdminUserIpRestrictionUserNameGetRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUserIpRestrictionUserNameGet(requestParameters.userName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminV2FacilitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV2FacilitiesGet(requestParameters: AdminApiAdminV2FacilitiesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetFacilitiesBussinessResponseV2> {
            return localVarFp.adminV2FacilitiesGet(requestParameters.facilityId, requestParameters.isUsingSaasAuthentication, requestParameters.isUsingMobile, requestParameters.isUsingSbvPro, requestParameters.addedToSaas, requestParameters.filter, requestParameters.pageSize, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminV2FacilityGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminV2FacilityGet(requestParameters: AdminApiAdminV2FacilityGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GetFacilitiesBussinessResponseV2> {
            return localVarFp.adminV2FacilityGet(requestParameters.facilityId, requestParameters.isUsingSaasAuthentication, requestParameters.isUsingMobile, requestParameters.isUsingSbvPro, requestParameters.addedToSaas, requestParameters.filter, requestParameters.pageSize, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminViventiumConfigurationViventiumConfigurationIdPut(requestParameters: AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminViventiumConfigurationViventiumConfigurationIdPut(requestParameters.viventiumConfigurationId, requestParameters.updateViventiumConfigurationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminBaseMenuIdDelete operation in AdminApi.
 * @export
 * @interface AdminApiAdminBaseMenuIdDeleteRequest
 */
export interface AdminApiAdminBaseMenuIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminBaseMenuIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for adminBaseMenuIdGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminBaseMenuIdGetRequest
 */
export interface AdminApiAdminBaseMenuIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminBaseMenuIdGet
     */
    readonly id: string
}

/**
 * Request parameters for adminBaseMenuIdPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminBaseMenuIdPutRequest
 */
export interface AdminApiAdminBaseMenuIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminBaseMenuIdPut
     */
    readonly id: string

    /**
     * 
     * @type {UpdateBaseMenuItemRequest}
     * @memberof AdminApiAdminBaseMenuIdPut
     */
    readonly updateBaseMenuItemRequest?: UpdateBaseMenuItemRequest
}

/**
 * Request parameters for adminBaseMenuPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminBaseMenuPostRequest
 */
export interface AdminApiAdminBaseMenuPostRequest {
    /**
     * 
     * @type {CreateBaseMenuItemRequest}
     * @memberof AdminApiAdminBaseMenuPost
     */
    readonly createBaseMenuItemRequest?: CreateBaseMenuItemRequest
}

/**
 * Request parameters for adminBulkResetPasswordPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminBulkResetPasswordPutRequest
 */
export interface AdminApiAdminBulkResetPasswordPutRequest {
    /**
     * 
     * @type {BulkResetPasswordRequest}
     * @memberof AdminApiAdminBulkResetPasswordPut
     */
    readonly bulkResetPasswordRequest?: BulkResetPasswordRequest
}

/**
 * Request parameters for adminCacheFacilityIdKeyDelete operation in AdminApi.
 * @export
 * @interface AdminApiAdminCacheFacilityIdKeyDeleteRequest
 */
export interface AdminApiAdminCacheFacilityIdKeyDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheFacilityIdKeyDelete
     */
    readonly facilityId: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheFacilityIdKeyDelete
     */
    readonly key: string
}

/**
 * Request parameters for adminCacheFacilityIdKeyGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminCacheFacilityIdKeyGetRequest
 */
export interface AdminApiAdminCacheFacilityIdKeyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheFacilityIdKeyGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheFacilityIdKeyGet
     */
    readonly key: string
}

/**
 * Request parameters for adminCacheKeyDelete operation in AdminApi.
 * @export
 * @interface AdminApiAdminCacheKeyDeleteRequest
 */
export interface AdminApiAdminCacheKeyDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheKeyDelete
     */
    readonly key: string
}

/**
 * Request parameters for adminCacheKeyGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminCacheKeyGetRequest
 */
export interface AdminApiAdminCacheKeyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminCacheKeyGet
     */
    readonly key: string
}

/**
 * Request parameters for adminConfigFacilityIdGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminConfigFacilityIdGetRequest
 */
export interface AdminApiAdminConfigFacilityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminConfigFacilityIdKeyGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminConfigFacilityIdKeyGetRequest
 */
export interface AdminApiAdminConfigFacilityIdKeyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdKeyGet
     */
    readonly key: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdKeyGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminConfigFacilityIdKeyValuePut operation in AdminApi.
 * @export
 * @interface AdminApiAdminConfigFacilityIdKeyValuePutRequest
 */
export interface AdminApiAdminConfigFacilityIdKeyValuePutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdKeyValuePut
     */
    readonly facilityId: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdKeyValuePut
     */
    readonly key: string

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdKeyValuePut
     */
    readonly value: string
}

/**
 * Request parameters for adminConfigFacilityIdPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminConfigFacilityIdPutRequest
 */
export interface AdminApiAdminConfigFacilityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminConfigFacilityIdPut
     */
    readonly facilityId: string

    /**
     * 
     * @type {ConfigurationSettingBulkUpsertModel}
     * @memberof AdminApiAdminConfigFacilityIdPut
     */
    readonly configurationSettingBulkUpsertModel?: ConfigurationSettingBulkUpsertModel
}

/**
 * Request parameters for adminDatabaseVersionFacilityIdGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminDatabaseVersionFacilityIdGetRequest
 */
export interface AdminApiAdminDatabaseVersionFacilityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminDatabaseVersionFacilityIdGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilitiesGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilitiesGetRequest
 */
export interface AdminApiAdminFacilitiesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilitiesGet
     */
    readonly filter?: string
}

/**
 * Request parameters for adminFacilityFacilityIdDelete operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdDeleteRequest
 */
export interface AdminApiAdminFacilityFacilityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdDelete
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilityFacilityIdGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdGetRequest
 */
export interface AdminApiAdminFacilityFacilityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilityFacilityIdMenuGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdMenuGetRequest
 */
export interface AdminApiAdminFacilityFacilityIdMenuGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdMenuGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilityFacilityIdMenuPermissionsPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest
 */
export interface AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdMenuPermissionsPost
     */
    readonly facilityId: string

    /**
     * 
     * @type {SetFacilityMenuPermissionsRequest}
     * @memberof AdminApiAdminFacilityFacilityIdMenuPermissionsPost
     */
    readonly setFacilityMenuPermissionsRequest?: SetFacilityMenuPermissionsRequest
}

/**
 * Request parameters for adminFacilityFacilityIdPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdPutRequest
 */
export interface AdminApiAdminFacilityFacilityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdPut
     */
    readonly facilityId: string

    /**
     * 
     * @type {FacilityUpdateRequest}
     * @memberof AdminApiAdminFacilityFacilityIdPut
     */
    readonly facilityUpdateRequest?: FacilityUpdateRequest
}

/**
 * Request parameters for adminFacilityFacilityIdRolesGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdRolesGetRequest
 */
export interface AdminApiAdminFacilityFacilityIdRolesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdRolesGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilityFacilityIdUsersGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdUsersGetRequest
 */
export interface AdminApiAdminFacilityFacilityIdUsersGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdUsersGet
     */
    readonly facilityId: string

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminFacilityFacilityIdUsersGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminFacilityFacilityIdUsersGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminFacilityFacilityIdViventiumConfigurationsGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest
 */
export interface AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdViventiumConfigurationsGet
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminFacilityFacilityIdViventiumConfigurationsPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest
 */
export interface AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityFacilityIdViventiumConfigurationsPost
     */
    readonly facilityId: string

    /**
     * 
     * @type {AddViventiumConfigurationRequest}
     * @memberof AdminApiAdminFacilityFacilityIdViventiumConfigurationsPost
     */
    readonly addViventiumConfigurationRequest?: AddViventiumConfigurationRequest
}

/**
 * Request parameters for adminFacilityGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilityGetRequest
 */
export interface AdminApiAdminFacilityGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminFacilityGet
     */
    readonly filter?: string
}

/**
 * Request parameters for adminFacilitySearchUsersPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminFacilitySearchUsersPostRequest
 */
export interface AdminApiAdminFacilitySearchUsersPostRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminFacilitySearchUsersPost
     */
    readonly onlyShowNewScheduler?: boolean

    /**
     * 
     * @type {SearchUserRequest}
     * @memberof AdminApiAdminFacilitySearchUsersPost
     */
    readonly searchUserRequest?: SearchUserRequest
}

/**
 * Request parameters for adminGlobalUserViewGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminGlobalUserViewGetRequest
 */
export interface AdminApiAdminGlobalUserViewGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly search?: string

    /**
     * 
     * @type {ModelString}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly phone?: ModelString

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly userName?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly phoneNumberConfirmed?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly isRegistered?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly isLocked?: boolean

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminGlobalUserViewGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for adminLockUserAccountPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminLockUserAccountPutRequest
 */
export interface AdminApiAdminLockUserAccountPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof AdminApiAdminLockUserAccountPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for adminOnboardEmployeesPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminOnboardEmployeesPostRequest
 */
export interface AdminApiAdminOnboardEmployeesPostRequest {
    /**
     * 
     * @type {OnboardEmployeesRequest}
     * @memberof AdminApiAdminOnboardEmployeesPost
     */
    readonly onboardEmployeesRequest?: OnboardEmployeesRequest
}

/**
 * Request parameters for adminOnboardFacilityPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminOnboardFacilityPostRequest
 */
export interface AdminApiAdminOnboardFacilityPostRequest {
    /**
     * 
     * @type {FacilitySetupRequest}
     * @memberof AdminApiAdminOnboardFacilityPost
     */
    readonly facilitySetupRequest?: FacilitySetupRequest
}

/**
 * Request parameters for adminRandomPasswordPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminRandomPasswordPostRequest
 */
export interface AdminApiAdminRandomPasswordPostRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof AdminApiAdminRandomPasswordPost
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for adminRegisterFacilityChatUsersFacilityIdPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest
 */
export interface AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminRegisterFacilityChatUsersFacilityIdPut
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminRegisterSystemUserPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminRegisterSystemUserPostRequest
 */
export interface AdminApiAdminRegisterSystemUserPostRequest {
    /**
     * 
     * @type {CreateAdminRequest}
     * @memberof AdminApiAdminRegisterSystemUserPost
     */
    readonly createAdminRequest?: CreateAdminRequest
}

/**
 * Request parameters for adminResendOtpAllUnregisteredPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminResendOtpAllUnregisteredPostRequest
 */
export interface AdminApiAdminResendOtpAllUnregisteredPostRequest {
    /**
     * 
     * @type {ResendOTPAllUnregisteredRequest}
     * @memberof AdminApiAdminResendOtpAllUnregisteredPost
     */
    readonly resendOTPAllUnregisteredRequest?: ResendOTPAllUnregisteredRequest
}

/**
 * Request parameters for adminResendOtpPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminResendOtpPutRequest
 */
export interface AdminApiAdminResendOtpPutRequest {
    /**
     * 
     * @type {ResendOtpFromAdminPortalRequest}
     * @memberof AdminApiAdminResendOtpPut
     */
    readonly resendOtpFromAdminPortalRequest?: ResendOtpFromAdminPortalRequest
}

/**
 * Request parameters for adminResetPasswordPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminResetPasswordPutRequest
 */
export interface AdminApiAdminResetPasswordPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof AdminApiAdminResetPasswordPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for adminScheduledJobsFacilityIdPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminScheduledJobsFacilityIdPostRequest
 */
export interface AdminApiAdminScheduledJobsFacilityIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminScheduledJobsFacilityIdPost
     */
    readonly facilityId: string
}

/**
 * Request parameters for adminSearchFacilityEmployeesPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminSearchFacilityEmployeesPostRequest
 */
export interface AdminApiAdminSearchFacilityEmployeesPostRequest {
    /**
     * 
     * @type {FacilitySearchUserRequest}
     * @memberof AdminApiAdminSearchFacilityEmployeesPost
     */
    readonly facilitySearchUserRequest?: FacilitySearchUserRequest
}

/**
 * Request parameters for adminUnlockUserAccountPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminUnlockUserAccountPutRequest
 */
export interface AdminApiAdminUnlockUserAccountPutRequest {
    /**
     * 
     * @type {LockUserAccountRequest}
     * @memberof AdminApiAdminUnlockUserAccountPut
     */
    readonly lockUserAccountRequest?: LockUserAccountRequest
}

/**
 * Request parameters for adminUserIpRestrictionDelete operation in AdminApi.
 * @export
 * @interface AdminApiAdminUserIpRestrictionDeleteRequest
 */
export interface AdminApiAdminUserIpRestrictionDeleteRequest {
    /**
     * 
     * @type {AddOrRemoveUserIpRestrictionRequest}
     * @memberof AdminApiAdminUserIpRestrictionDelete
     */
    readonly addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest
}

/**
 * Request parameters for adminUserIpRestrictionPost operation in AdminApi.
 * @export
 * @interface AdminApiAdminUserIpRestrictionPostRequest
 */
export interface AdminApiAdminUserIpRestrictionPostRequest {
    /**
     * 
     * @type {AddOrRemoveUserIpRestrictionRequest}
     * @memberof AdminApiAdminUserIpRestrictionPost
     */
    readonly addOrRemoveUserIpRestrictionRequest?: AddOrRemoveUserIpRestrictionRequest
}

/**
 * Request parameters for adminUserIpRestrictionUserNameGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminUserIpRestrictionUserNameGetRequest
 */
export interface AdminApiAdminUserIpRestrictionUserNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminUserIpRestrictionUserNameGet
     */
    readonly userName: string
}

/**
 * Request parameters for adminV2FacilitiesGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminV2FacilitiesGetRequest
 */
export interface AdminApiAdminV2FacilitiesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly facilityId?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly isUsingSaasAuthentication?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly isUsingMobile?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly isUsingSbvPro?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly addedToSaas?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly filter?: string

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminV2FacilitiesGet
     */
    readonly page?: number
}

/**
 * Request parameters for adminV2FacilityGet operation in AdminApi.
 * @export
 * @interface AdminApiAdminV2FacilityGetRequest
 */
export interface AdminApiAdminV2FacilityGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly facilityId?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly isUsingSaasAuthentication?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly isUsingMobile?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly isUsingSbvPro?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly addedToSaas?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly filter?: string

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof AdminApiAdminV2FacilityGet
     */
    readonly page?: number
}

/**
 * Request parameters for adminViventiumConfigurationViventiumConfigurationIdPut operation in AdminApi.
 * @export
 * @interface AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest
 */
export interface AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApiAdminViventiumConfigurationViventiumConfigurationIdPut
     */
    readonly viventiumConfigurationId: string

    /**
     * 
     * @type {UpdateViventiumConfigurationRequest}
     * @memberof AdminApiAdminViventiumConfigurationViventiumConfigurationIdPut
     */
    readonly updateViventiumConfigurationRequest?: UpdateViventiumConfigurationRequest
}

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @param {AdminApiAdminBaseMenuIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBaseMenuIdDelete(requestParameters: AdminApiAdminBaseMenuIdDeleteRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBaseMenuIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminBaseMenuIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBaseMenuIdGet(requestParameters: AdminApiAdminBaseMenuIdGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBaseMenuIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminBaseMenuIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBaseMenuIdPut(requestParameters: AdminApiAdminBaseMenuIdPutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBaseMenuIdPut(requestParameters.id, requestParameters.updateBaseMenuItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminBaseMenuPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBaseMenuPost(requestParameters: AdminApiAdminBaseMenuPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBaseMenuPost(requestParameters.createBaseMenuItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBaseMenusGet(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBaseMenusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminBulkResetPasswordPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBulkResetPasswordPut(requestParameters: AdminApiAdminBulkResetPasswordPutRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBulkResetPasswordPut(requestParameters.bulkResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminCacheFacilityIdKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCacheFacilityIdKeyDelete(requestParameters: AdminApiAdminCacheFacilityIdKeyDeleteRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCacheFacilityIdKeyDelete(requestParameters.facilityId, requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminCacheFacilityIdKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCacheFacilityIdKeyGet(requestParameters: AdminApiAdminCacheFacilityIdKeyGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCacheFacilityIdKeyGet(requestParameters.facilityId, requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminCacheKeyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCacheKeyDelete(requestParameters: AdminApiAdminCacheKeyDeleteRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCacheKeyDelete(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminCacheKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminCacheKeyGet(requestParameters: AdminApiAdminCacheKeyGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminCacheKeyGet(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminConfigFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminConfigFacilityIdGet(requestParameters: AdminApiAdminConfigFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminConfigFacilityIdGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminConfigFacilityIdKeyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminConfigFacilityIdKeyGet(requestParameters: AdminApiAdminConfigFacilityIdKeyGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminConfigFacilityIdKeyGet(requestParameters.key, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminConfigFacilityIdKeyValuePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminConfigFacilityIdKeyValuePut(requestParameters: AdminApiAdminConfigFacilityIdKeyValuePutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminConfigFacilityIdKeyValuePut(requestParameters.facilityId, requestParameters.key, requestParameters.value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminConfigFacilityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminConfigFacilityIdPut(requestParameters: AdminApiAdminConfigFacilityIdPutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminConfigFacilityIdPut(requestParameters.facilityId, requestParameters.configurationSettingBulkUpsertModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminDashboardGet(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminDatabaseVersionFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminDatabaseVersionFacilityIdGet(requestParameters: AdminApiAdminDatabaseVersionFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminDatabaseVersionFacilityIdGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilitiesGet(requestParameters: AdminApiAdminFacilitiesGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilitiesGet(requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdDelete(requestParameters: AdminApiAdminFacilityFacilityIdDeleteRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdDelete(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdGet(requestParameters: AdminApiAdminFacilityFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdMenuGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdMenuGet(requestParameters: AdminApiAdminFacilityFacilityIdMenuGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdMenuGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdMenuPermissionsPost(requestParameters: AdminApiAdminFacilityFacilityIdMenuPermissionsPostRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdMenuPermissionsPost(requestParameters.facilityId, requestParameters.setFacilityMenuPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdPut(requestParameters: AdminApiAdminFacilityFacilityIdPutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdPut(requestParameters.facilityId, requestParameters.facilityUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdRolesGet(requestParameters: AdminApiAdminFacilityFacilityIdRolesGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdRolesGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdUsersGet(requestParameters: AdminApiAdminFacilityFacilityIdUsersGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdUsersGet(requestParameters.facilityId, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdViventiumConfigurationsGet(requestParameters: AdminApiAdminFacilityFacilityIdViventiumConfigurationsGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdViventiumConfigurationsGet(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityFacilityIdViventiumConfigurationsPost(requestParameters: AdminApiAdminFacilityFacilityIdViventiumConfigurationsPostRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityFacilityIdViventiumConfigurationsPost(requestParameters.facilityId, requestParameters.addViventiumConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilityGet(requestParameters: AdminApiAdminFacilityGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilityGet(requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminFacilitySearchUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminFacilitySearchUsersPost(requestParameters: AdminApiAdminFacilitySearchUsersPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminFacilitySearchUsersPost(requestParameters.onlyShowNewScheduler, requestParameters.searchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminGlobalUserViewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminGlobalUserViewGet(requestParameters: AdminApiAdminGlobalUserViewGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminGlobalUserViewGet(requestParameters.search, requestParameters.phone, requestParameters.userName, requestParameters.phoneNumberConfirmed, requestParameters.isRegistered, requestParameters.isLocked, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminLockUserAccountPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminLockUserAccountPut(requestParameters: AdminApiAdminLockUserAccountPutRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminLockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminOnboardEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOnboardEmployeesPost(requestParameters: AdminApiAdminOnboardEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOnboardEmployeesPost(requestParameters.onboardEmployeesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminOnboardFacilityPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOnboardFacilityPost(requestParameters: AdminApiAdminOnboardFacilityPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOnboardFacilityPost(requestParameters.facilitySetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminPopulateDbConfigPut(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminPopulateDbConfigPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminRandomPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminRandomPasswordPost(requestParameters: AdminApiAdminRandomPasswordPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminRandomPasswordPost(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminRefreshTeamSupportCustomersPost(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminRefreshTeamSupportCustomersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminRegisterFacilityChatUsersFacilityIdPut(requestParameters: AdminApiAdminRegisterFacilityChatUsersFacilityIdPutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminRegisterFacilityChatUsersFacilityIdPut(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminRegisterSystemUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminRegisterSystemUserPost(requestParameters: AdminApiAdminRegisterSystemUserPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminRegisterSystemUserPost(requestParameters.createAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminResendOtpAllUnregisteredPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminResendOtpAllUnregisteredPost(requestParameters: AdminApiAdminResendOtpAllUnregisteredPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminResendOtpAllUnregisteredPost(requestParameters.resendOTPAllUnregisteredRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminResendOtpPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminResendOtpPut(requestParameters: AdminApiAdminResendOtpPutRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminResendOtpPut(requestParameters.resendOtpFromAdminPortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminResetPasswordPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminResetPasswordPut(requestParameters: AdminApiAdminResetPasswordPutRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminResetPasswordPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminScheduledJobsDelete(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminScheduledJobsDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminScheduledJobsFacilityIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminScheduledJobsFacilityIdPost(requestParameters: AdminApiAdminScheduledJobsFacilityIdPostRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminScheduledJobsFacilityIdPost(requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminScheduledJobsPost(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminScheduledJobsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminSchedulerDbMigrateAllPut(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminSchedulerDbMigrateAllPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminSearchFacilityEmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminSearchFacilityEmployeesPost(requestParameters: AdminApiAdminSearchFacilityEmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminSearchFacilityEmployeesPost(requestParameters.facilitySearchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminTimezonesGet(options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminTimezonesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminUnlockUserAccountPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminUnlockUserAccountPut(requestParameters: AdminApiAdminUnlockUserAccountPutRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminUnlockUserAccountPut(requestParameters.lockUserAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminUserIpRestrictionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminUserIpRestrictionDelete(requestParameters: AdminApiAdminUserIpRestrictionDeleteRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminUserIpRestrictionDelete(requestParameters.addOrRemoveUserIpRestrictionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminUserIpRestrictionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminUserIpRestrictionPost(requestParameters: AdminApiAdminUserIpRestrictionPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminUserIpRestrictionPost(requestParameters.addOrRemoveUserIpRestrictionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminUserIpRestrictionUserNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminUserIpRestrictionUserNameGet(requestParameters: AdminApiAdminUserIpRestrictionUserNameGetRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminUserIpRestrictionUserNameGet(requestParameters.userName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminV2FacilitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminV2FacilitiesGet(requestParameters: AdminApiAdminV2FacilitiesGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminV2FacilitiesGet(requestParameters.facilityId, requestParameters.isUsingSaasAuthentication, requestParameters.isUsingMobile, requestParameters.isUsingSbvPro, requestParameters.addedToSaas, requestParameters.filter, requestParameters.pageSize, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminV2FacilityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminV2FacilityGet(requestParameters: AdminApiAdminV2FacilityGetRequest = {}, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminV2FacilityGet(requestParameters.facilityId, requestParameters.isUsingSaasAuthentication, requestParameters.isUsingMobile, requestParameters.isUsingSbvPro, requestParameters.addedToSaas, requestParameters.filter, requestParameters.pageSize, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminViventiumConfigurationViventiumConfigurationIdPut(requestParameters: AdminApiAdminViventiumConfigurationViventiumConfigurationIdPutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminViventiumConfigurationViventiumConfigurationIdPut(requestParameters.viventiumConfigurationId, requestParameters.updateViventiumConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
